module.exports = __webpack_public_path__ + "img/Ishmael-Beah.6c11afd3.jpg";